import StoreButtons from '../StoreButtons';

const CTASection = () => (
  <section className="relative py-24 bg-[#0c4f7d] overflow-hidden" data-testid="cta-section">
    <div className="absolute inset-0 opacity-20">
      <img
        src="https://images.unsplash.com/photo-1527489377706-5bf97e608852?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
        alt=""
        aria-hidden="true"
        className="w-full h-full object-cover"
      />
    </div>
    <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Ready to Fish Smarter?</h2>
      <p className="text-xl text-cyan-100 mb-10 max-w-2xl mx-auto">
        Download FlyFinder free and get the exact fly, size, and technique for your water &mdash; right now.
      </p>
      <StoreButtons />
    </div>
  </section>
);

export default CTASection;
